import { render, staticRenderFns } from "./activityPublish.vue?vue&type=template&id=7d5c4923"
import script from "./activityPublish.vue?vue&type=script&lang=js"
export * from "./activityPublish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports